<ion-header>
            <ion-row class="header-container">
                <ion-col class="header-first-row">
                        <div class="header-group">
                            <!-- <button ion-button *ngIf="selectedSegmentButton == 'massenstart'" icon-only clear (click)="openScoreBoardMassenstart()">
                                <ion-icon name="list"></ion-icon>
                            </button> -->
                            <!-- <button ion-button *ngIf="selectedSegmentButton == 'einzelstart'" icon-only clear (click)="openScoreBoardEinzelstart(einelstartAthletesArray)">
                                <ion-icon name="list"></ion-icon>
                            </button> -->
                            <!-- <button ion-button *ngIf="selectedSegmentButton?.includes('wellenstart')" icon-only clear (click)="openScoreBoardWallen(athletesArray)">
                                <ion-icon name="list"></ion-icon>
                            </button> -->
                        </div>
                        <div>
                            <button ion-button icon-only clear (click)="onConfigureModal()">
                                <ion-icon name="settings"></ion-icon>
                            </button>
                        </div>
                </ion-col>
            </ion-row>
</ion-header>     
<ion-content>
    <ion-row class="select-row">
        <ion-col>
            <ion-select (ionChange)="eventNameChange($event)" placeholder="Rennen nach Namen" class="header-select" multiple="false">
                <ion-option [value]="raceByName">Rennen nach Namen</ion-option>
                <ion-option [value]="raceByBib">Rennen nach Startnummer</ion-option>
                <ion-option *ngFor="let event of events; let i = index" [value]="event" [selected]="getActiveIndex(i)">{{ event.date | transDate: 'dd.MM.yyyy' }} - {{event.enaOrig}}-{{event.streckeconv}} - {{ event.cid | categoryName | async | translate }}</ion-option>
            </ion-select>
        </ion-col>
    </ion-row>
    <race-by-name *ngIf="raceByName"></race-by-name>
    <race-by-bib class="race-by-bib" *ngIf="raceByBib"></race-by-bib>
    <leader-activity *ngIf="leaderActivity" (selectedSegmentEvent)="getSelectedSegmentButton($event)" (scoreBoardEvent)="getScoreBoardData($event)" [einelstartAthletesArray]= "einelstartAthletesArray" [massenstartAthletesArray]="massenstartAthletesArray" [athletesArray]="athletesArray"></leader-activity>
</ion-content>